import { VFC } from 'react'
import styled from 'styled-components'
import { RadioButtonCheckedIcon } from '../../../assets/svgs'
import { contributionGray, errorRed, truewhite } from '../../../styles/colors'

export const ItemTitle: VFC<{
  title: string
  checked: boolean
  optional?: true
}> = ({ title, checked, optional }) => {
  return (
    <>
      <ItemTitleDiv>
        <h3>{title}</h3>
        {!optional &&
          (checked ? (
            <RadioButtonCheckedIcon />
          ) : (
            <RequirementSpan>必須</RequirementSpan>
          ))}
      </ItemTitleDiv>
    </>
  )
}

const ItemTitleDiv = styled.div`
  display: flex;
  margin-top: 20px;
  line-height: 24px;

  h3 {
    margin-right: 10px;
    color: ${contributionGray};
  }
`

const RequirementSpan = styled.span`
  padding: 0px 11px;
  height: 24px;
  font-size: 13px;
  color: ${truewhite};
  background-color: ${errorRed};
  border-radius: 12px;
`
